webpackJsonp([89],{

/***/ 1116:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(true);
// imports


// module
exports.push([module.i, ".SlideImages1 amp-img{width:100%}", "", {"version":3,"sources":["/Users/yuki/Public/wp-admin/src/components/contents/SlideImages1/src/components/contents/SlideImages1/SlideImages1.s.scss"],"names":[],"mappings":"AAEA,sBAEI,UAAW,CACZ","file":"SlideImages1.s.scss","sourcesContent":["@import '~scss/variables';\n\n.SlideImages1 {\n  amp-img {\n    width: 100%;\n  }\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 410:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1116);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(342)("3bc5f92c", content, true, {});

/***/ })

});


// WEBPACK FOOTER //
// static/js/89.321ae7bbebb12d8b71af.js